import { render, staticRenderFns } from "./SalespersonAnalytics.vue?vue&type=template&id=48371554&scoped=true"
import script from "./SalespersonAnalytics.vue?vue&type=script&lang=js"
export * from "./SalespersonAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48371554",
  null
  
)

export default component.exports